import React from "react";
import clsx from "clsx";
import { FieldError, FieldValues, UseFormRegister } from "react-hook-form";

type Props = {
  placeholder?: string | null | undefined;
  required?: boolean;
  error?: FieldError;
  defaultValue?: string;
  className?: string;
};

// you can use React.forwardRef to pass the ref too
export const WTextArea = React.forwardRef<
  HTMLTextAreaElement,
  Props & ReturnType<UseFormRegister<FieldValues>>
>(
  (
    {
      onChange,
      onBlur,
      name,
      placeholder,
      required,
      error,
      defaultValue,
      className,
      disabled,
    },
    ref
  ) => {
    return (
      <div className="ek-input">
        <textarea
          placeholder=" "
          className={clsx([
            error?.type && "error-input",
            className,
            disabled && "cursor-not-allowed",
          ])}
          name={name}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          defaultValue={defaultValue}
        ></textarea>
        <div className="ek-placeholder">
          {placeholder}
          {required && <span className="text-red-500">*</span>}
        </div>
        {error?.type && <div className="input-error-text">{error.message}</div>}
      </div>
    );
  }
);
WTextArea.displayName = "TextArea";

export default WTextArea;
